<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tmSE9C/tc-custom/9781488025129.jpg?1694036365696" alt="This image is the cover for the book Art of Keeping Secrets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Art of Keeping Secrets
      </h1>
      <p class="bookDescription body article font2">
        <b>Some Secrets Weren’t Meant to Be Kept…</b><br/><br/>They started out as the “misfit moms”—the trio of less-than-conventional parents at their sons’ tiny private school. They’ve shared everything. Or so they thought. Now, on a once-in-a-lifetime trip to New York City, they’ll sightsee, they’ll shop, they’ll catch a few Broadway shows. They’ll tell all…<br/><br/>After seventeen years as a single parent, Neve will reveal a past sin that could destroy her relationship with her son. Emma will uncover the roots of her exhaustion and divulge the inappropriate feelings she has for her boss. And Flick—who knows a little about crafting a flawless exterior—will share the shocking truth that lies beneath the veneer of her perfect marriage.<br/><br/>When the tight hold they’ve each kept on their secrets for years begins to slip, they must face the truth. Even if the truth will forever alter the course of their friendship and their lives.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachael Johns
      </h2>
      
      <p class="authorDescription body article">Rachael Johns is an English teacher by trade, a mum 24/7, a chronic arachnophobic, and a writer the rest of the time. She rarely sleeps and never irons. A lover of contemporary romance and women’s fiction. She lives in Western Australia with her hyperactive husband, three mostly-gorgeous heroes-in-training, two fat cats, a cantankerous bird and a very badly behaved dog. Rachael loves to hear from readers and can be contacted via her website – www.rachaeljohns.com, Facebook or Twitter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e460b5f